import React, { useCallback, useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import Dropzone from './components/dropZone';
import NeedHelp from '../Elements/NeedHelp';
import { getInitialRoute, TOAST_ERROR } from '../../../../../../utils';
import CheckBoxField from '../Elements/CheckboxField';
import InfoSection from '../Elements/InfoSection';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { toast } from 'react-toastify';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import { shallowEqual, useSelector } from 'react-redux';
import { togglePlanSection } from '../../../../../../actions/show_modal_Action';
import { togglePlanSection_D } from '../../../../../../actions/showDisplayModalAction';
import { useDispatch } from 'react-redux';
import LinkedInUpgrade from './components/LinkedInUpgrade';

const initialPopStatus = { status: false, msg: null };
let toastId = null;
export default function Linkedinfeed({ feedInfo, networkId, hideAddfeed, onBack, onFilterNameChange, wallId, createdFeeds, showUpgradePop, navigation, isLimitExceed }) {
    const [imageUrl, setImageUrl] = useState(null);
    const [fileName, setFileName] = useState('Your selected file name');
    const [field, setField] = useState('');
    const [needAproval, setApproval] = useState(false);
    const [error, seterror] = useState(false);
    const [filterType, setFilterType] = useState('company Page');
    const [inputState, setInputState] = useState({
        hashtag: "",
        handle: "",
        companyUrl: "",
        hashtagError: false,
        handleError: false,
        companyUrlError: false
    });
    const [showUpgrade, setUpgradePop] = useState(initialPopStatus);
    const dispatch = useDispatch();
    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const [loading, setLoading] = useState(false);
    const linkedInFeeds = createdFeeds.reduce((acc, curr) => { if (curr.networkId == 10 && ![16, 18].includes(parseInt(curr.filterId))) acc++; return acc; }, 0);

    const onUploadSuccess = useCallback((fileName, url) => {
        setImageUrl(url);
        setFileName(fileName);
    }, []);

    const updateInputState = (event) => {
        const key = `${event.target.name}Error`;
        setInputState(prev => ({ ...prev, [event.target.name]: event.target.value, [key]: false }))
    }


    const submit = () => {

        const { handle, hashtag, companyUrl } = inputState;

        if (['handle', 'company Page'].includes(filterType) && isLimitExceed) {
            setInputState(prev => ({ ...prev, handleError: false, companyUrlError: false }));
            TOAST_ERROR("Please Upgrade your plan to add more feeds")
            return
        }

        if (filterType == 'post Url' && field == '') {
            seterror(true);
        } else if (filterType == 'bulk Urls' && imageUrl == null) {
            toast.error("Please upload a Csv File", { autoClose: 2000 });
        } else if (filterType == 'handle' && inputState.handle == '') {
            setInputState(prev => ({ ...prev, handleError: true }));
        } else if (filterType == 'hashtag' && inputState.hashtag == '') {
            setInputState(prev => ({ ...prev, hashtagError: true }));
        } else if (filterType == 'company Page' && inputState.companyUrl == '') {
            setInputState(prev => ({ ...prev, companyUrlError: true }));
        } else {
            const filterId = getFilterType();
            const obj = {
                wallId: wallId,
                networkId: networkId,
                filter: filterId,
                field: filterType == "post Url" ? field : filterId == 1 ? handle : filterId == 2 ? hashtag.split('#').join('') : filterId == 17 ? companyUrl.split('/mycompany')[0] : imageUrl,
                moderation: needAproval ? 1 : 0
            }
            if ((filterId == 1 || filterId == 16 || filterId == 17) && !obj.field.includes('https:')) {
                toast.error("Please enter a valid url", { autoClose: 2000 });
                return;
            }

            // Checking for pro conditions 
            const isRequestInValid = upgradeRequired(filterType);
            if (isRequestInValid.msg == 'limit exhausted') {
                if (!toastId) {
                    toastId = toast.error('LinkedIn feed limit exhausted!!!', { autoClose: 3000 });
                    setTimeout(() => toastId = null, 3000)
                }
                return;
            }

            setLoading(true);
            createFeedAction(obj, networkId, (feedId, responseCode) => {
                setLoading(false);
                if (feedId) {
                    navigation(`/moderation/index/${wallId}`);
                    hideAddfeed();
                } else {
                    if (responseCode == 401) {
                        showUpgradePop();
                    }
                }
            });
        }
    }

    const getFilterType = () => {
        return feedInfo[0].networkTab.reduce((acc, curr) => {
            if ((curr.feedtype).toLowerCase() === (filterType).toLowerCase()) {
                return curr.filter;
            }
            return acc;
        }, feedInfo[0].networkTab[0].filter)
    }

    const upgradePlan = () => {
        const product = getInitialRoute() != 'widget';
        setUpgradePop(initialPopStatus);
        if (product) dispatch(togglePlanSection_D(true));
        else dispatch(togglePlanSection(true))
    }

    // check linkedIn upgrade condition (hashtag, handle and companyUrl) for different plans
    const upgradeRequired = (tabName) => {
        const widgetProduct = getInitialRoute() == 'widget';
        let result = initialPopStatus;
        if (userData && userData.UserRule && userData.UserPlan) {
            const linkedInPlanLimit = userData.UserRule.linkedInFeedLimit;
            const planIds = userData.UserPlan.planId.split(',');
            const isLimitExhausted = linkedInFeeds >= linkedInPlanLimit;
            if (['handle', 'hashtag', 'company Page'].includes(tabName)) {
                if (planIds.includes('1') && isLimitExhausted) {
                    result = { status: true, msg: 'Oops, Looks like you have exhausted the feed limit for the Free Trial. Upgrade for more feeds.' };
                } else {
                    // condition with status = false and msg = "limit exhausted" are for showing error toaster for highest plan
                    if (widgetProduct) {
                        if (planIds.includes('42')) result = { status: true, msg: 'Sorry, The option with the Auto-Update feature is not available in Lite Plan. Move to an advanced plan to use this option.' };
                        else if (planIds.includes('28') && isLimitExhausted) result = { status: true, msg: `Looks like you've exhausted your linkedIn feed limit for this plan. Want more LinkedIn feeds? Switch to Pro.` };
                        else if (planIds.includes('29') && isLimitExhausted) result = { status: false, msg: `limit exhausted` };
                    } else {
                        if (planIds.includes('31') && isLimitExhausted) result = { status: true, msg: `Looks like you've exhausted your feed limit for this plan. Want more LinkedIn feeds? Switch to Professional Plan.` };
                        else if (planIds.includes('61') && isLimitExhausted) result = { status: true, msg: `Looks like you've exhausted your feed limit for this plan. Want more LinkedIn feeds? Switch to Agency Plan.` };
                        else if (planIds.includes('52') && isLimitExhausted) result = { status: false, msg: `limit exhausted` };
                        else if (planIds.includes('55') && isLimitExhausted) result = { status: false, msg: `limit exhausted` };
                    }
                }
            }
        }

        return result;
    }

    const changeTab = (event) => {
        const upgradeDetails = upgradeRequired(event);
        if (upgradeDetails.status) setUpgradePop(upgradeDetails);
        else setUpgradePop(upgradeDetails);

        setFilterType(event);
        onFilterNameChange(event);
    }

    useEffect(() => {
        let filter = 'company Page';
        const upgradeDetails = upgradeRequired(filter);
        if (upgradeDetails.status) {
            filter = 'post Url';
            setFilterType(filter);
            setUpgradePop(upgradeDetails);
        }
        onFilterNameChange(filter);
    }, [])

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-body">
                    <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                        <Tabs activeKey={filterType} defaultActiveKey="company Page" id="CreateFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={changeTab}>
                            <Tab eventKey="company Page" className="nav-link p-0 ms-0 mt-2" title={<span>Company Page</span>}>
                                {showUpgrade.status ? <LinkedInUpgrade modalShow={showUpgrade.status} msg={showUpgrade.msg} closeModal={() => setUpgradePop(initialPopStatus)} showPricing={upgradePlan} /> : <>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fas fa-link"></i>
                                                </span>
                                            </div>
                                            <input autoComplete="off" className="form-control" id="FeedLinkedin_company" placeholder="Enter Company Page URL: https://www.linkedin.com/company/tagbox/" type="text" name="companyUrl" value={inputState.companyUrl} onChange={(e) => updateInputState(e)} />
                                        </div>
                                        {inputState.companyUrlError && <span id="feedslinkedin_post_urlerror" className="errorMessage required">This field is required.</span>}
                                    </div>
                                    <div className="form-group hideforBSearch">
                                        <div className="checkbox-inline mb-2">
                                            <CheckBoxField isChecked={needAproval} onChangeHandler={(e) => setApproval(e.target.checked)} name={"moderation"} id="linkedin_company" />
                                        </div>
                                    </div>
                                    <InfoSection text={userData && userData.UserPlan && Object.keys(userData.UserPlan).length > 0 && ["42", "1"].some((value) => userData.UserPlan.planId.split(',').includes(value)) ? <>{userData.UserPlan.planId.split(',').includes('42') ? 'The latest posts from the company page will first be added to the feed. You can also enable this auto-update feature with our Paid Plans. ' : 'Please note that you can use this option to get content but the Auto Update feature is not available in the Trial Plan. '}<span className='text-link cursor-pointer' onClick={upgradePlan}>Upgrade Now</span> </> : <>The latest posts from the company page will first be added to the feed. After that, the feed will update itself every 24 hours.</>} />
                                </>}

                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        {getInitialRoute() === 'widget' ?
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/704076511'} supportLink={'https://taggbox.com/support/embed-linkedin-on-website/'} />
                                            :
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/540124440/ad20ab23b1'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={submit} onBack={onBack} loading={loading} disabled={showUpgrade.status} />
                                    </div>
                                </div>
                            </Tab>

                            <Tab eventKey="handle" className="nav-link p-0 ms-0 mt-2" title={<span>Handle</span>}>
                                {showUpgrade.status ? <LinkedInUpgrade modalShow={showUpgrade.status} msg={showUpgrade.msg} closeModal={() => setUpgradePop(initialPopStatus)} showPricing={upgradePlan} /> : <>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="fas fa-at"></i>
                                                </span>
                                            </div>
                                            <input autoComplete="off" className="form-control" placeholder="Enter Profile Page URL: https://www.linkedin.com/in/williamhgates/" type="text" id="FeedLinkedin_handle" name="handle" value={inputState.handle} onChange={(e) => updateInputState(e)} />
                                        </div>
                                        {inputState.handleError && <span id="feedslinkedin_post_urlerror" className="errorMessage required">This field is required.</span>}
                                    </div>
                                    <div className="form-group hideforBSearch">
                                        <div className="checkbox-inline mb-2">
                                            <CheckBoxField isChecked={needAproval} onChangeHandler={(e) => setApproval(e.target.checked)} name={"moderation"} id="linkedin_handle" />
                                        </div>
                                    </div>
                                    <InfoSection text={userData && userData.UserPlan && Object.keys(userData.UserPlan).length > 0 && ["42", "1"].some((value) => userData.UserPlan.planId.split(',').includes(value)) ? <>{userData.UserPlan.planId.split(',').includes('42') ? 'Choose the LinkedIn handle you want to fetch data from.  Switch now to a paid plan to auto-update your feed. ' : 'Please note that you can use this option to get content but the Auto Update feature is not available in the Trial Plan. '}<span className='text-link cursor-pointer' onClick={upgradePlan}>Upgrade Now</span> </> : <>Choose the LinkedIn handle you want to fetch data from.  The feed gets auto-updated every 24 hours to keep the page fresh and engaging.</>} />
                                    {showUpgrade.status ? <LinkedInUpgrade modalShow={showUpgrade.status} msg={showUpgrade.msg} closeModal={() => setUpgradePop(initialPopStatus)} showPricing={upgradePlan} /> : null}
                                </>}

                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        {getInitialRoute() === 'widget' ?
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/704076511'} supportLink={'https://taggbox.com/support/embed-linkedin-on-website/'} />
                                            :
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/540124440/ad20ab23b1'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={submit} onBack={onBack} loading={loading} disabled={showUpgrade.status} />
                                    </div>
                                </div>
                            </Tab>
                            {userData?.UserRule?.linkedinhashtag == 1 ?
                                <Tab eventKey="hashtag" className="nav-link p-0 ms-0 mt-2" title={<span>Hashtag</span>}>
                                    {showUpgrade.status ? <LinkedInUpgrade modalShow={showUpgrade.status} msg={showUpgrade.msg} closeModal={() => setUpgradePop(initialPopStatus)} showPricing={upgradePlan} /> : <>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="fas fa-hashtag"></i>
                                                    </span>
                                                </div>
                                                <input autoComplete="off" className="form-control" id="FeedLinkedin_hashtag" placeholder="Enter Hashtag" type="text" name="hashtag" value={inputState.hashtag} onChange={(e) => updateInputState(e)} />
                                            </div>
                                            {inputState.hashtagError && <span id="feedslinkedin_post_urlerror" className="errorMessage required">This field is required.</span>}
                                        </div>
                                        <div className="form-group hideforBSearch">
                                            <div className="checkbox-inline mb-2">
                                                <CheckBoxField isChecked={needAproval} onChangeHandler={(e) => setApproval(e.target.checked)} name={"moderation"} id="linkedin_hashtag" />
                                            </div>
                                        </div>
                                        <InfoSection text={userData && userData.UserPlan && Object.keys(userData.UserPlan).length > 0 && ["42", "1"].some((value) => userData.UserPlan.planId.split(',').includes(value)) ? <>{userData.UserPlan.planId.split(',').includes('42') ? 'Initially, a limited set of historical posts will be aggregated, after which new posts will be compiled every 24 hours.' : 'Please note that you can use this option to get content but the Auto Update feature is not available in the Trial Plan. '}<span className='text-link cursor-pointer' onClick={upgradePlan}> Upgrade Now </span> </> : <>Initially, a limited set of historical posts will be aggregated, after which new posts will be compiled every 24 hours.</>} />
                                    </>}
                                    <div className="form-actions w-100">
                                        <div className="f-between flex-wrap border-top pt-3 mt-4">
                                            {getInitialRoute() === 'widget' ?
                                                <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/704076511'} supportLink={'https://taggbox.com/support/embed-linkedin-on-website/'} />
                                                :
                                                <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/540124440/ad20ab23b1'} supportLink={''} />
                                            }
                                            <SubmitFeedRequest onSubmit={submit} onBack={onBack} loading={loading} disabled={showUpgrade.status} />
                                        </div>
                                    </div>
                                </Tab> : ''}

                            <Tab eventKey="post Url" className="nav-link p-0 ms-0 mt-2" title={<span>Post Url</span>}>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-flag"></i>
                                            </span>
                                        </div>
                                        <input autoComplete="off" className="form-control" placeholder="Enter LinkedIn Post Url" type="text" id="FeedLinkedin_posturl" value={field} onChange={(e) => { if (error) { seterror(false) } setField(e.target.value) }} />
                                    </div>
                                    {error && <span id="feedslinkedin_post_urlerror" className="errorMessage required">This field is required.</span>}
                                </div>
                                <div className="form-group hideforBSearch">
                                    <div className="checkbox-inline mb-2">
                                        <CheckBoxField isChecked={needAproval} onChangeHandler={(e) => setApproval(e.target.checked)} name={"moderation"} id="linkedin_posturl" />
                                    </div>
                                </div>
                                <InfoSection text={"Fetch content like Images, Videos, and Text posts from LinkedIn by adding post URL."} />
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        {getInitialRoute() === 'widget' ?
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/704076511'} supportLink={'https://taggbox.com/support/embed-linkedin-on-website/'} />
                                            :
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/540124440/ad20ab23b1'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={submit} onBack={onBack} loading={loading} />
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="bulk Urls" className="nav-link p-0" title={<span>Bulk URLs</span>}>
                                <Dropzone onUploadSuccess={onUploadSuccess} fileName={fileName} />
                                <div className="form-group hideforBSearch">
                                    <div className="checkbox-inline mb-2">
                                        <CheckBoxField isChecked={needAproval} onChangeHandler={(e) => setApproval(e.target.checked)} name={"moderation"} id="linkedin_bulkurls" />
                                    </div>
                                </div>
                                <InfoSection text={"Get up to 50 LinkedIn posts in bulk by adding multiple post URLs in CSV format."} />
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        {getInitialRoute() === 'widget' ?
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/704076511'} supportLink={'https://taggbox.com/support/embed-linkedin-on-website/'} />
                                            :
                                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/540124440/ad20ab23b1'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={submit} onBack={onBack} loading={loading} />
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>

    )
}
